import {
  TextField,
  Grid2 as Grid,
  FormControl,
  FormLabel,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { formControlStyle, formLabelStyle } from "@features/common/styles";
import { getCustomerObj } from "@features/customers/customerSlice";

export const BasicInfo = () => {
  const { t } = useTranslation();

  // Since editing customers is not a feature right now, this isEditing is always false
  // This should be replaced with a useState when editing is available
  const isEditing = false;

  const customer = useSelector(getCustomerObj);

  return (
    <>
      <FormControl component="fieldset" sx={formControlStyle}>
        <FormLabel component="legend" sx={formLabelStyle}>
          {t("basic-info")}
        </FormLabel>

        <Grid container spacing={2}>
          <Grid
            container
            size={{ xs: 12, sm: 6 }}
            spacing={2}
            direction={{ sm: "column" }}
          >
            <Grid size={{ xs: 12 }}>
              <TextField
                label={t("customer-name")}
                data-testid="customer-name"
                value={customer?.customer_name}
                fullWidth
                slotProps={{ input: { readOnly: !isEditing } }}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                label={t("customer-timezone")}
                data-testid="customer-timezone"
                disabled={true}
                value={customer?.timezone}
                fullWidth
              />
            </Grid>
            {customer?.gcp_projects && customer?.gcp_projects?.length > 0 && (
              <Grid size={{ xs: 12 }}>
                <TextField
                  label={t("label-customer-gcp-projects")}
                  data-testid="customer-gcp-projects"
                  disabled={true}
                  value={customer?.gcp_projects.join("\n")}
                  multiline
                  rows={4}
                  fullWidth
                />
              </Grid>
            )}
            {customer?.azure_resourcegroups &&
              customer?.azure_resourcegroups?.length > 0 && (
                <Grid size={{ xs: 12 }}>
                  <TextField
                    label={t("label-customer-azure-resourcegroups")}
                    data-testid="customer-azure-resourcegroups"
                    disabled={true}
                    value={customer?.azure_resourcegroups.join("\n")}
                    multiline
                    rows={4}
                    fullWidth
                  />
                </Grid>
              )}
          </Grid>
          <Grid
            container
            size={{ xs: 12, sm: 6 }}
            spacing={3}
            direction={"column"}
          >
            <Grid size={{ xs: 12 }}>
              <FormControl component="fieldset" sx={formControlStyle}>
                <FormLabel component="legend" sx={formLabelStyle}>
                  {t("label-generated-ids")}
                </FormLabel>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12 }}>
                    <TextField
                      label={t("customer-guid")}
                      data-testid="customer-guid"
                      value={customer?.customer_guid}
                      disabled
                      fullWidth
                    />
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <TextField
                      label={t("lowercase-customer-name")}
                      data-testid="lowercase-customer-name"
                      value={customer?.customer_name.toLowerCase()}
                      disabled
                      fullWidth
                    />
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <TextField
                      label={t("tech-customer-name")}
                      data-testid="tech-customer-name"
                      value={customer?.tech_customer_name}
                      disabled
                      fullWidth
                    />
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <TextField
                      label={t("short-customer-name")}
                      data-testid="short-customer-name"
                      value={customer?.short_customer_name}
                      disabled
                      fullWidth
                    />
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <TextField
                      label={t("short-lowercase-customer-name")}
                      data-testid="short-lowercase-customer-name"
                      value={customer?.short_customer_name.toLowerCase()}
                      disabled
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </FormControl>
    </>
  );
};
